import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTrainerroadComponent } from './simple-icons-trainerroad.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTrainerroadComponent ],
    exports:      [ SimpleIconsTrainerroadComponent ],
    bootstrap:    []
})
export class SimpleIconsTrainerroadModule {}
